import type { DisplayRow } from "./buildDisplayRows";

export type SortColumn = "name" | "members" | "roles";
export type SortDirection = "asc" | "desc";

export function filterRows<M>(
  rows: readonly DisplayRow<M>[],
  search: string
): DisplayRow<M>[] {
  const lower = search.toLowerCase();
  if (!lower) return [...rows];
  return rows.filter((r) => r.name.toLowerCase().includes(lower));
}

export function sortRows<M>(
  rows: readonly DisplayRow<M>[],
  column: SortColumn | null,
  direction: SortDirection
): DisplayRow<M>[] {
  const list = [...rows];
  if (!column) return list;
  list.sort((a, b) => {
    let aVal: string | number;
    let bVal: string | number;
    switch (column) {
      case "name":
        aVal = a.name.toLowerCase();
        bVal = b.name.toLowerCase();
        break;
      case "members":
        aVal = a.memberCount;
        bVal = b.memberCount;
        break;
      case "roles":
        aVal = (a.roleBadges[0]?.label ?? "").toLowerCase();
        bVal = (b.roleBadges[0]?.label ?? "").toLowerCase();
        break;
    }
    if (aVal < bVal) return direction === "asc" ? -1 : 1;
    if (aVal > bVal) return direction === "asc" ? 1 : -1;
    return 0;
  });
  return list;
}
